import { IconCritical, Text } from '@hudl/uniform-ui-components';
import React, { ReactNode } from 'react';
import PageBackground from '../PageBackground';
import * as styles from './styles.scss';

interface ErrorBoundaryProps {
  environment?: 'light' | 'dark';
  errorMessage?: string;
  children: ReactNode;
}
interface ErrorBoundaryState {
  hasError: boolean;
}

// You cannot write error boundaries as a functional component, hence I'm using React.Component
class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = {
      hasError: false,
    };
  }

  render() {
    const fallbackMessage = `We've encountered a problem while loading this page.`;

    if (this.state.hasError) {
      return (
        <PageBackground environment={this.props.environment ?? 'dark'}>
          <div className={styles.errorBoundaryContainer}>
            <IconCritical className={styles.criticalIcon} />
            <Text>{this.props.errorMessage ? this.props.errorMessage : fallbackMessage}</Text>
          </div>
        </PageBackground>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
